export default __webpack_public_path__ + "static/media/cs2.0dc6a95e.jpg";